/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DokumentAktivierenRequest } from '../model/dokumentAktivierenRequest';
// @ts-ignore
import { DokumentAktualisierenRequest } from '../model/dokumentAktualisierenRequest';
// @ts-ignore
import { DokumentBerechtigungRolleMultiRequest } from '../model/dokumentBerechtigungRolleMultiRequest';
// @ts-ignore
import { DokumentBerechtigungRolleRequest } from '../model/dokumentBerechtigungRolleRequest';
// @ts-ignore
import { DokumentEntfernenRequest } from '../model/dokumentEntfernenRequest';
// @ts-ignore
import { DokumentHinzufuegenRequest } from '../model/dokumentHinzufuegenRequest';
// @ts-ignore
import { DokumentIdentifier } from '../model/dokumentIdentifier';
// @ts-ignore
import { DokumentUploadAktualisierenRequest } from '../model/dokumentUploadAktualisierenRequest';
// @ts-ignore
import { DokumentVeranstaltungsTypMultiRequest } from '../model/dokumentVeranstaltungsTypMultiRequest';
// @ts-ignore
import { DokumentVeranstaltungsTypenRequest } from '../model/dokumentVeranstaltungsTypenRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class DokumentCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostDokumentAktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/aktivieren
     * @param dokumentAktivierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentAktivieren(dokumentAktivierenRequest: DokumentAktivierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentAktivieren(dokumentAktivierenRequest: DokumentAktivierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentAktivieren(dokumentAktivierenRequest: DokumentAktivierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentAktivieren(dokumentAktivierenRequest: DokumentAktivierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentAktivierenRequest === null || dokumentAktivierenRequest === undefined) {
            throw new Error('Required parameter dokumentAktivierenRequest was null or undefined when calling postDokumentAktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/aktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentAktivierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/aktualisieren
     * @param dokumentAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentAktualisierenRequest === null || dokumentAktualisierenRequest === undefined) {
            throw new Error('Required parameter dokumentAktualisierenRequest was null or undefined when calling postDokumentAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/bearbeiten/entfernen
     * @param dokumentBerechtigungRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleRequest === null || dokumentBerechtigungRolleRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleRequest was null or undefined when calling postDokumentBearbeitenBerechtigungEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/bearbeiten/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/bearbeiten/entfernen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentBearbeitenBerechtigungEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/bearbeiten/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen
     * @param dokumentBerechtigungRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleRequest === null || dokumentBerechtigungRolleRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleRequest was null or undefined when calling postDokumentBearbeitenBerechtigungHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentBearbeitenBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/entfernen
     * @param dokumentBerechtigungRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleRequest === null || dokumentBerechtigungRolleRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleRequest was null or undefined when calling postDokumentBerechtigungEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/entfernen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentBerechtigungEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/hinzufuegen
     * @param dokumentBerechtigungRolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRolleRequest: DokumentBerechtigungRolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleRequest === null || dokumentBerechtigungRolleRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleRequest was null or undefined when calling postDokumentBerechtigungHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/hinzufuegen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/entfernen
     * @param dokumentEntfernenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentEntfernenRequest === null || dokumentEntfernenRequest === undefined) {
            throw new Error('Required parameter dokumentEntfernenRequest was null or undefined when calling postDokumentEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentEntfernenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * BenutzerKeinVorlagenAdmin: (VorlageBenutzerKeinVorlagenAdmin) 
     * @endpoint post /api/vorl/command/dokumente/v1/hinzufuegen
     * @param dokumentHinzufuegenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentHinzufuegenRequest === null || dokumentHinzufuegenRequest === undefined) {
            throw new Error('Required parameter dokumentHinzufuegenRequest was null or undefined when calling postDokumentHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentHinzufuegenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentLeseBerechtigungEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/lesen/entfernen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentLeseBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentLeseBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungEntfernenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentLeseBerechtigungEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/lesen/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentLeseBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/berechtigung/lesen/hinzufuegen/multi
     * @param dokumentBerechtigungRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungRolleMultiRequest: DokumentBerechtigungRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRolleMultiRequest === null || dokumentBerechtigungRolleMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRolleMultiRequest was null or undefined when calling postDokumentLeseBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/berechtigung/lesen/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentUploadAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/uploadaktualisieren
     * @param dokumentUploadAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentUploadAktualisierenRequest === null || dokumentUploadAktualisierenRequest === undefined) {
            throw new Error('Required parameter dokumentUploadAktualisierenRequest was null or undefined when calling postDokumentUploadAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/uploadaktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentUploadAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentVeranstaltungsTypenAktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/veranstaltungstypen/aktivieren
     * @param dokumentVeranstaltungsTypenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentVeranstaltungsTypenAktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentVeranstaltungsTypenAktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenAktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenAktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentVeranstaltungsTypenRequest === null || dokumentVeranstaltungsTypenRequest === undefined) {
            throw new Error('Required parameter dokumentVeranstaltungsTypenRequest was null or undefined when calling postDokumentVeranstaltungsTypenAktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/veranstaltungstypen/aktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentVeranstaltungsTypenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentVeranstaltungsTypenDeaktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/veranstaltungstypen/deaktivieren
     * @param dokumentVeranstaltungsTypenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentVeranstaltungsTypenDeaktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentVeranstaltungsTypenDeaktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenDeaktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenDeaktivieren(dokumentVeranstaltungsTypenRequest: DokumentVeranstaltungsTypenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentVeranstaltungsTypenRequest === null || dokumentVeranstaltungsTypenRequest === undefined) {
            throw new Error('Required parameter dokumentVeranstaltungsTypenRequest was null or undefined when calling postDokumentVeranstaltungsTypenDeaktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/veranstaltungstypen/deaktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentVeranstaltungsTypenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentVeranstaltungsTypenEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/veranstaltungstypen/entfernen
     * @param dokumentVeranstaltungsTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentVeranstaltungsTypenEntfernen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentVeranstaltungsTypenEntfernen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenEntfernen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenEntfernen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentVeranstaltungsTypMultiRequest === null || dokumentVeranstaltungsTypMultiRequest === undefined) {
            throw new Error('Required parameter dokumentVeranstaltungsTypMultiRequest was null or undefined when calling postDokumentVeranstaltungsTypenEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/veranstaltungstypen/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentVeranstaltungsTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentVeranstaltungsTypenHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineBearbeitenBerechtigung: (VorlageDokumentKannNichtBearbeiten) * DokumentEntfernt: (VorlageDokumentIstEntfernt) * DokumentNichtGefunden: (VorlageDokumentNichtGefunden) 
     * @endpoint post /api/vorl/command/dokumente/v1/veranstaltungstypen/hinzufuegen
     * @param dokumentVeranstaltungsTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentVeranstaltungsTypenHinzufuegen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentVeranstaltungsTypenHinzufuegen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenHinzufuegen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentVeranstaltungsTypenHinzufuegen(dokumentVeranstaltungsTypMultiRequest: DokumentVeranstaltungsTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentVeranstaltungsTypMultiRequest === null || dokumentVeranstaltungsTypMultiRequest === undefined) {
            throw new Error('Required parameter dokumentVeranstaltungsTypMultiRequest was null or undefined when calling postDokumentVeranstaltungsTypenHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/dokumente/v1/veranstaltungstypen/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentVeranstaltungsTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
